import React from 'react';
import { TFunction } from 'i18next';

// assets
import GreenCheckIcon from 'shared/assets/green-check.svg?react';

// styles
import * as Styled from 'demoRegistration/styles/RegistrationFormSubmitted.style';
import * as Text from 'theme/components/Text.style';
import { Link } from '@mui/material';
import { Trans } from 'react-i18next';

interface RegistrationSuccessProps {
  t: TFunction;
}

const RegistrationSuccess: React.FC<RegistrationSuccessProps> = ({ t }) => {
  // Helper function to safely cast translation results
  const translate = (key: string): string => t(key) as unknown as string;

  return (
    <Styled.Section>
      <Styled.SuccessCard>
        <GreenCheckIcon />
        <Text.H3>{translate("You're all set!")}</Text.H3>
        <Text.P3>
          {translate(
            "To access the app, simply click on the link provided in your inbox. Remember to check your spam folder if you don't see the email from us in your inbox."
          )}
        </Text.P3>

        <Text.P3>
          <Trans
            i18nKey="reachUsSuccess"
            components={[
              <Link key="0" href="mailto:info@nurau.com" underline="none" />,
            ]}
            ns="pageDemoRegistration"
          />
        </Text.P3>
        <Text.P3>{translate('Happy exploring!')}</Text.P3>
      </Styled.SuccessCard>
    </Styled.Section>
  );
};

export default RegistrationSuccess;
